import { useEffect } from 'react'

const MAX_CHARACTERS_FOR_ONE_LINE = 26
const MAX_CHARACTERS_FOR_ONE_LINE_LARGE = 34

const useMaxCTALengthWarning = ({ customCTA, large, uniqueId }) => {
  useEffect(() => {
    const maxCharacters = large ? MAX_CHARACTERS_FOR_ONE_LINE_LARGE : MAX_CHARACTERS_FOR_ONE_LINE

    if (customCTA && customCTA.length > maxCharacters) {
      // eslint-disable-next-line no-console
      console.warn(
        `SDK Warning: The length of customCTA exceeded the max amount of characters (${maxCharacters}) per line. It's been truncated in order to match one line. \nWidget uniqueId: ${uniqueId}`,
      )
    }
  }, [customCTA])
}

export default useMaxCTALengthWarning
